import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import CountUp from "react-countup";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "../styles/careers.css";

export default function Blog() {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>
            <h1>Blog</h1>

            {/* Testimonials Section */}
            <section className="section" id="testimonials">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="center-heading">
                                <h2 className="section-title">What do they say?</h2>
                            </div>
                        </div>
                        <div className="offset-lg-3 col-lg-6">
                            <div className="center-text">
                                <p>
                                    Donec tempus, sem non rutrum imperdiet, lectus orci fringilla nulla, at accumsan elit eros a turpis. Ut sagittis lectus libero.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {[
                            { name: "Catherine Soft", role: "Managing Director", text: "Proin a neque nisi...", img: "http://placehold.it/60x60" },
                            { name: "Kelvin Wood", role: "Digital Marketer", text: "Integer molestie aliquam gravida...", img: "http://placehold.it/60x60" },
                            { name: "David Martin", role: "Website Manager", text: "Quisque diam odio...", img: "http://placehold.it/60x60" }
                        ].map((testimonial, index) => (
                            <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                                <div className="team-item">
                                    <div className="team-content">
                                        <i>
                                            <img src="assets/images/testimonial-icon.png" alt="testimonial icon" />
                                        </i>
                                        <p>{testimonial.text}</p>
                                        <div className="user-image">
                                            <img src={testimonial.img} alt="user" />
                                        </div>
                                        <div className="team-info">
                                            <h3 className="user-name">{testimonial.name}</h3>
                                            <span>{testimonial.role}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Facts Section */}
            <div className="container-xxl bg-primary fact py-5" data-aos="fade-up">
                <Container className="py-5 px-lg-5">
                    <Row className="g-4">
                        {/* Years Experience */}
                        <Col md={6} lg={3} className="text-center" data-aos="fade-up" data-aos-delay="100">
                            <i className="fa fa-certificate fa-3x text-secondary mb-3"></i>
                            <h1 className="text-white mb-2">
                                <CountUp end={1234} duration={3} />
                            </h1>
                            <p className="text-white mb-0">Years Experience</p>
                        </Col>

                        {/* Team Members */}
                        <Col md={6} lg={3} className="text-center" data-aos="fade-up" data-aos-delay="300">
                            <i className="fa fa-users-cog fa-3x text-secondary mb-3"></i>
                            <h1 className="text-white mb-2">
                                <CountUp end={1234} duration={3} />
                            </h1>
                            <p className="text-white mb-0">Team Members</p>
                        </Col>

                        {/* Satisfied Clients */}
                        <Col md={6} lg={3} className="text-center" data-aos="fade-up" data-aos-delay="500">
                            <i className="fa fa-users fa-3x text-secondary mb-3"></i>
                            <h1 className="text-white mb-2">
                                <CountUp end={1234} duration={3} />
                            </h1>
                            <p className="text-white mb-0">Satisfied Clients</p>
                        </Col>

                        {/* Completed Projects */}
                        <Col md={6} lg={3} className="text-center" data-aos="fade-up" data-aos-delay="700">
                            <i className="fa fa-check fa-3x text-secondary mb-3"></i>
                            <h1 className="text-white mb-2">
                                <CountUp end={1234} duration={3} />
                            </h1>
                            <p className="text-white mb-0">Completed Projects</p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
